document.addEventListener("on:cart-drawer:after-open", function () {
  const intervalId = setInterval(() => {
    const target = document.querySelector("body .section-cart-drawer .drawer .tl__cart-goal__container__drawer>p:last-child");
    if (target) {
      target.remove();
      clearInterval(intervalId);
    }
  }, 100);
});

document.addEventListener("DOMContentLoaded", function () {
  const intervalId = setInterval(() => {
		const target = document.querySelector("body .shopify-block.shopify-app-block .tl-discount-tier-container>p:last-child") ||
						 document.querySelector("body .tl__cart-goal__container__drawer>p:last-child");
    if (target) {
      target.remove();
      clearInterval(intervalId);
    }
  }, 100);
});

document.addEventListener("on:cart:after-merge", function () {
  const intervalId = setInterval(() => {
    const target = document.querySelector("body .section-cart-drawer .drawer .tl__cart-goal__container__drawer>p:last-child");
    if (target) {
      target.remove();
      clearInterval(intervalId);
    }
  }, 100);
});
